// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import Stripe                   from 'stripe';

// ===== Interfaces =====

import {
    ICartItem,
    IStripePaymentIntentArgs,
}                               from '../interfaces';

const stripeCreatePaymentIntent = async ({
    test,
    cartItems,
    userEmail,
    customerId,
}: IStripePaymentIntentArgs): Promise<Stripe.PaymentIntent> => {
    const functions = getFunctions();
    const createPaymentIntent = httpsCallable<
        Record<
            string,
            boolean | string | ICartItem[]
        >,
        Stripe.PaymentIntent
    >(
        functions,
        'stripeCreatePaymentIntent',
    );

    const args: Record<string, boolean | string | ICartItem[]> = {
        test,
        cartItems,
    };
    if (userEmail) args.userEmail = userEmail;
    if (customerId) args.customerId = customerId;
    return createPaymentIntent(args).then((result) => {
        const paymentIntent = result.data as Stripe.PaymentIntent;
        return paymentIntent;
    }).catch((err) => {
        throw err;
    });
};

export default stripeCreatePaymentIntent;
